import { ApiClientReturnType, Nullable } from '~/types';
import api from '../http-common';

export enum FixedPricePrefixType {
  FixedPrice = 'fixed-price',
  FatProtein = 'fat-protein',
  StockExchange = 'stock-exchange',
}

export const DashboardService = (prefix: FixedPricePrefixType) => {

  const getNextTradingSlot = () =>
    api.post(`/dashboard/${prefix}/get-next-trading-slot`);

  const getPreviousTradingSlot = () =>
    api.post(`/dashboard/${prefix}/get-previous-trading-slot`);

  const getChartTradingData = () =>
    api.post(`/dashboard/${prefix}/trading-activities/get-chart-data`);

  const getSettings = (): any =>
    api.post(`/${prefix}/trading-slots/get-settings-data`)

  return {
    getNextTradingSlot,
    getPreviousTradingSlot,
    getChartTradingData,
    getSettings
  }

}

export const getCo2Data = (data: { farmerId: string | number }): ApiClientReturnType<DashboardCO2Type> =>
  api.post('dashboard/co2-footprint/get-data', data)

export const getCo2Options = (): ApiClientReturnType<DashboardCO2OptionsType> =>
  api.post('dashboard/co2-footprint/get-options-data')

export interface DashboardCO2Type {
  avgResultFarmer: Nullable<AvgResultFarmType>;
  defaultResult: number;
  lastCo2Footprint: Nullable<LastCo2Footprint>;
  co2Data: Nullable<Co2Data>;
  avgDairyResults: string | number;
}

export type AvgResultFarmType = {
  value: number | string,
  inventoryAddition: number | string,
  calfRearing: number | string,
  feeding: number | string,
  manureAndBedding: number | string,
  waterAndEnergy: number | string,
  dieselProductionAndCombustion: number | string,
  total: number | string
}

export interface Co2Data {
  id: string;
  totalMilkAmount: number;
  cowsNumber: string;
  milkAmount: number;
  breeds: Breed[];
  fat: number;
  protein: number;
}

export interface Breed {
  id: string;
  slug: string;
  status: number;
  label: string;
  co2FootprintAnswerId: number;
  breedId: number;
  percent: string;
}

export interface LastCo2Footprint {
  id: string;
  title: string;
  start: string;
  end: string;
  periodFrom: Date;
  periodTo: Date;
  uniqueId?: string;
  statusLabel: string;
  createdAt: Nullable<string>;
}

export interface DashboardCO2OptionsType {
  farmers: Farmer[];
  co2FootprintSettings: Co2FootprintSettings;
  texts: Text[];
}

export interface Co2FootprintSettings {
  bayernValueColor: string
  dairyValueColor: string
  yourValueColor: string
  showLflDefaultValue: number
}

export interface Farmer {
  farmerId: string;
  companyName: string;
  supplierNo: string;
}

export interface Text {
  slug: string;
  label: string;
  id: number;
  code: string;
  icon: string;
  translation: string;
  textId: number;
  languageId: number;
}

